import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-xai-large.tsx
/**
* icon.24.logo.xai.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEwLjkyMiA1LjUxYTYuNzMgNi43MyAwIDAgMSAzLjg4LjM2OWMuNDg5LjE4Ny45NS40NCAxLjM3Mi43NWwtMi4wMy45MzdjLTEuODg5LS43OTMtNC4wNTMtLjI1My01LjM3MyAxLjA2OS0xLjczIDEuNzMxLTIuMTI0IDQuNjkzLS4yNDMgNi42OTdsLjE4Ny4xOTNMMyAyMC42MzVjLjM2Mi0uNDk5LjgxMy0uOTcgMS4yNjItMS40NDMgMS4yNjUtMS4zMzIgMi41MjEtMi42NTEgMS43NTUtNC41MTYtMS4wMjYtMi40OTYtLjQyOC01LjQyMSAxLjQ3MS03LjMyM2E2LjczIDYuNzMgMCAwIDEgMy40MzQtMS44NDNtOS45NDQtMS45NjljLTEuODggMi41OTQtMi44IDMuODY0LTIuMDYyIDcuMDM4bC0uMDA1LS4wMDZjLjUwOCAyLjE2MS0uMDM1IDQuNTU4LTEuNzkxIDYuMzE2LTIuMjEzIDIuMjE3LTUuNzU1IDIuNzEtOC42NzIuNzE1bDIuMDMzLS45NDRjMS44NjIuNzMyIDMuOS40MTIgNS4zNjItMS4wNTRhNC45MyA0LjkzIDAgMCAwIDEuMDU4LTUuMzc2Yy0uMTQtLjMzNy0uNTYtLjQyMi0uODU0LS4yMDVMOS45NSAxNC40NWw4LjU3NC04LjYyMnYuMDA3TDIxIDMuMzU1cS0uMDY2LjA5NS0uMTM0LjE4NiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11367
*/
const Icon24LogoXaiLarge = memo(function Icon24LogoXaiLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M10.922 5.51a6.73 6.73 0 0 1 3.88.369c.489.187.95.44 1.372.75l-2.03.937c-1.889-.793-4.053-.253-5.373 1.069-1.73 1.731-2.124 4.693-.243 6.697l.187.193L3 20.635c.362-.499.813-.97 1.262-1.443 1.265-1.332 2.521-2.651 1.755-4.516-1.026-2.496-.428-5.421 1.471-7.323a6.73 6.73 0 0 1 3.434-1.843m9.944-1.969c-1.88 2.594-2.8 3.864-2.062 7.038l-.005-.006c.508 2.161-.035 4.558-1.791 6.316-2.213 2.217-5.755 2.71-8.672.715l2.033-.944c1.862.732 3.9.412 5.362-1.054a4.93 4.93 0 0 0 1.058-5.376c-.14-.337-.56-.422-.854-.205L9.95 14.45l8.574-8.622v.007L21 3.355q-.066.095-.134.186"
		})
	});
});
//#endregion
export { Icon24LogoXaiLarge };

//# sourceMappingURL=icon-24-logo-xai-large.js.map